import React from 'react';

import InterdisciplinaryScienceSubjectPage from '../containers/InterdisciplinaryScienceSubjectPage';

const InterdisciplinaryScienceSubjectPageApp = (props) => (
  <InterdisciplinaryScienceSubjectPage {...props} />
);

export default InterdisciplinaryScienceSubjectPageApp
